import {
  modalConfirmationImportInterlocuteurs,
  modalConfirmationTelechargementInterlocuteurs,
} from '../../../pages/gestion-interlocuteurs-en-masse/main.js';
import { StoreManager } from '../../services/store-manager.js';
import { TacheManager } from '../../services/tache-manager.js';
import MicroApp from './micro-app-base.js';

/**
 * Microapp Gestion interlocuteurs en masse
 */
export default class GestionInterlocuteursEnMasseMicroApp extends MicroApp {
  /**
   * Surcharge pour réagir aux messages de la microapp
   */
  childPymEvents = {
    openModalConfirmationImportInterlocuteurs: () => {
      const nomCollectivite = StoreManager.getSelectedCollectivites().localite;

      document.querySelector('#modal-confirmation-import-interlocuteurs').title =
        `Déclarer plusieurs interlocuteurs pour ${nomCollectivite}`;
      modalConfirmationImportInterlocuteurs.show();
    },
    openModalConfirmationTelechargementInterlocuteurs: (jsonTache) => {
      const tache = JSON.parse(jsonTache);
      TacheManager.ajouter([tache]);
      modalConfirmationTelechargementInterlocuteurs.show();
    },
  };

  /**
   * Initialise une nouvelle instance de type {@type GestionInterlocuteursEnMasseMicroApp}.
   */
  constructor() {
    super();
  }
}
